import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { SCRAPED_PRODUCT_CACHE_KEY } from "./keys";

import { ScrapedProductFilters } from "@/types/scraped-product";
import { ScrapedProductRepository } from "@/repositories/scraped-product";

export const useGetScrapedProducts = (filters: ScrapedProductFilters) => {
  const scrapedProductRepository = useRef(new ScrapedProductRepository());

  return useQuery({
    queryKey: SCRAPED_PRODUCT_CACHE_KEY.LIST(filters),
    queryFn: async () => {
      return await scrapedProductRepository.current.findAll(filters);
    },
    placeholderData: keepPreviousData,
  });
};
